export function buildIndex(roots) {
  const byId = {};
  const parent = {};
  (function walk(list, par) {
    (list || []).forEach((n) => {
      byId[n.id] = n;
      parent[n.id] = par;
      if (n.children) walk(n.children, n);
    });
  })(roots || [], null);

  const pathOf = (id) => {
    const out = [];
    let cur = byId[id];
    while (cur) {
      out.unshift(cur);
      cur = parent[cur.id] || null;
    }
    return out;
  };
  return { byId, parent, pathOf };
}

export default buildIndex;
